import React, { useEffect, useState } from "react";
import MainComponent from "../MainComponent";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Objective from "../../assets/images/Objective.svg";
import Goals from "../../assets/images/Goals.svg";
import InputField from "./InputField";
import Arrow from "../../assets/images/arrow-circle-down.svg";
import ArrowSIMP from "../../assets/images/arrow-bottom.svg";
import Repeat from "../../assets/images/repeat.svg";
import AddColorIcon from "../../assets/images/plus-fill.svg";
import "./XLExecutionPlan.css";
import ElipsisVerticalIcon from "../../assets/images/ellipsis-vertical-solid.svg";
import ProfileAdd from "../../assets/images/profile-add.svg";
import EditIcon from "../../assets/images/Edit.svg";
import DeleteIcon from "../../assets/images/trash.svg";
import AddFolder from "../../assets/images/add-folder.png";
import { v4 as uuidv4 } from "uuid";
import ManageOptions from "./ManageOptions";
import AddExistingpopup from "./AddExistingpopup";
import ChevronRight from "../../assets/images/Chevron-right.svg";
import keys from "../../utils/helpInfoKeys.json";
import Select from "react-select";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Assign from "../../assets/images/assign.svg";
import { motion } from "motion/react";
import FunctionalGoal from "../../assets/images/fg.svg";
import {
  getEmployeeData,
  getMasterTaskPriorityAndStatusData,
  getXLExecutionPlanDetails,
  postCopyMasterFunctionsXLStrategy,
  postEditStrategyObjective,
  postStrategyFunctions,
  postStrategyGoals,
  resetExceptionError,
  getAiGeneratedGoals,
  postaiGeneratedGoals
} from "../../store/actions";
import XLExecutionPlanSidebar from "./XLExecutionPlanSidebar";
import { createImageFromInitials, getRandomColor } from "../Utils";
import DisabledGoalSelector from "./DisabledGoalSelector";
import CommentSection from "../../utils/CommentSection";
import Login from "../Login";
import SideNavHelpInfo from "../../utils/SideNavHelpInfo";
import DuplicateTaskPopup from "./DuplicateTaskPopup";
import { createStatus } from "./WorkboardProgress";
import Alert from "../Alert";
import TextField from "@mui/material/TextField";

import Drawer from "@mui/material/Drawer";
import Checkbox from "@mui/material/Checkbox";
import { HiSparkles } from "react-icons/hi2";
import { AiOutlineCaretLeft, AiOutlineCaretRight } from "react-icons/ai";
import { RESET_AI_GENERATED_GOALS } from "../../store/actions/actionTypes";
import TreeView from "./TreeView"
import { TiDelete } from "react-icons/ti";

function XLExecutionPlan() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  const [biName, setBIName] = useState(null);
  const [isobjectiveVisible, setIsObjectiveVisible] = useState(true);
  const [isGoalVisible, setIsGoalVisible] = useState(true);
  const [isFunctionVisible, setIsFunctionVisible] = useState(true);
  const [issimpVisible, setIsSimpVisible] = useState(true);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [objectiveData, setObjectiveData] = useState([]);
  const [objectiveList, setObjectiveList] = useState([]);
  const [goalData, setGoalData] = useState([]);
  const [functionData, setFunctionData] = useState([]);
  const [goalList, setGoalList] = useState([]);
  const [functionList, setFunctionList] = useState([]);
  const [functionModel, setFunctionModel] = useState(false);
  const [isMilestoneVisible, setIsMilestoneVisible] = useState(true);
  const [selectedFunctionIndex, setSelectedFunctionIndex] = useState(-1);
  const [collapsedItems, setCollapsedItems] = useState({});
  const [strategicItems, setStrategicItems] = useState({});
  const [newStrategicItem, setNewStrategicItem] = useState("");
  const selectedBI = useSelector((state) => state.selectedBI);
  const selectedSubMenuPermission = useSelector(
    (state) => state.selectedSubMenuPermission
  );
  const [showIcons, setShowIcons] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [GoalModalIsOpen, setGoalModalIsOpen] = useState(false);
  const [onElipsisshowIcons, setOnElipsisshowIcons] = useState(false);
  const [currentItemId, setCurrentItemId] = useState("");
  const [singleGoal, setSingleGoal] = useState(false);
  const [show, setShow] = useState(false);
  const [showGoalPopup, setShowGoalPopup] = useState(false);
  const [showFunctionPopup, setShowFunctionPopup] = useState(false);
  const [showSimpPopup, setShowSimpPopup] = useState(false);
  const [showMilestonePopup, setShowMilestonePopup] = useState(false);
  const [milestoneItems, setMilestoneItems] = useState({});
  const [newMilestoneItem, setNewMilestoneItem] = useState("");
  const [currentFunctionIndex, setCurrentFunctionIndex] = useState("");
  const [currentImperativeIndex, setCurrentImperativeIndex] = useState("");
  const [currentMilestoneIndex, setCurrentMilestoneIndex] = useState("");
  const [editPopupshow, setEditPopupShow] = useState(false);
  const [currentFunctionId, setCurrentFunctionId] = useState("");
  const [currentImperativeId, setCurrentImperativeId] = useState("");
  const [currentMilestoneId, setCurrentMilestoneId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [sidebarType, setSidebarType] = useState();
  const [placeholder, setPlaceholder] = useState();
  const [AssingOwnerClick, setAssignOwnerClick] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [userPermission, setUserPermission] = useState("");
  const [userDueDatePermission, setUserDueDatePermission] = useState("");
  const strategyPlanData = useSelector((state) => state.strategyPlanData);
  const isGoalDataFetched = useSelector((state) => state.isGoalDataFetched);
  const isFunctionDataFetched = useSelector(
    (state) => state.isFunctionDataFetched
  );
  const postGoalDetails = useSelector((state) => state.postGoalDetails);
  const postStrategyFunctionDetails = useSelector(
    (state) => state.postStrategyFunctionDetails
  );
  const getEmployeeDetails = useSelector((state) => state.getEmployeeDetails);
  const [empData, setEmpData] = useState(null);
  const [dropdownGoalData, setDropdownGoalData] = useState([]);
  const [strategicItemValues, setStrategicItemValues] = useState(
    Array(functionList.length).fill("")
  );
  const [milestoneValues, setMilestoneValues] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [aiFunctionName, setAiFunctionName] = useState("");
  const [aiFunctionId, setAiFunctionId] = useState("");
  const [statusData, setStatusData] = useState([]);
  const [priorityData, setPriorityData] = useState([]);
  const getMasterTasksPriorityAndStatusDetails = useSelector(
    (state) => state.getMasterTasksPriorityAndStatusDetails
  );
  const fecthPostDuplicateTasksData = useSelector(
    (state) => state.fecthPostDuplicateTasksData
  );
  const [showDuplicateTaskPopup, setShowDuplicateTaskPopup] = useState(false);
  const [duplicateTaskId, setDuplicateTaskId] = useState("");
  const [duplicateTaskName, setDuplicateTaskName] = useState("");

  const [showAiGenerate, setShowAiGenerate] = useState(false);
  const [aiEdit, setAiEdit] = useState(false);
  const [goals, setGoals] = useState([]);
  const [aiFullScreenMode, setAiFullScreenMode] = useState(false)
  const [aiButtonEnabled, setAiButtonEnabled] = useState(false);

  const fetchgetChatbot = useSelector((state) => state.fetchgetChatbot);

  const aiGeneratedGoals = useSelector((state) => state.fetchGetAiGeneratedGoals);

  const fetchPostCreateAiGeneratedGoals = useSelector((state) => state.fetchPostCreateAiGeneratedGoals);

  const updateStrategicItemValue = (index, value) => {
    const updatedValues = [...strategicItemValues];
    updatedValues[index] = value;
    setStrategicItemValues(updatedValues);
  };
  const handleAssignOwnerClick = (e, fun_id) => {
    e.preventDefault();
    setCurrentFunctionId(fun_id);
    setAssignOwnerClick(true);
  };
  const handleDuplicateTaskClick = (id, task_title) => {
    setDuplicateTaskId(id);
    setDuplicateTaskName(task_title);
  };
  const handleDTPopupClose = () => {
    setShowDuplicateTaskPopup(false);
  };
  const handleDTPopupShow = () => {
    setShowDuplicateTaskPopup(true);
  };
  const [formData, setFormData] = useState({
    name: "",
    assigned_to: null,
  });
  const customFilter = (option, searchText) => {
    if (option.data.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      assigned_to: e.label,
    });
    setSelectedOption(e);
  };
  useEffect(() => {
    setSelectedOption();
  }, []);

  const handleOwnerSubmit = (e) => {
    e.preventDefault();
    const assignedToList = [formData.assigned_to];
    const requiredAssignedData = empData.map((item) => ({
      key: item.value,
      is_active: assignedToList.some(
        (selectedItem) => selectedItem === item.label
      ),
      label: item.label,
    }));
    let data = [
      {
        bi_id: localStorage.getItem("bi_id"),
        product_id: localStorage.getItem("product_id"),
        function_id: currentFunctionId,
        assigned_to: requiredAssignedData,
        is_active: true,
      },
    ];
    dispatch(postStrategyFunctions(data, "function", true));
    setAssignOwnerClick(false);
    setCurrentFunctionId("");
  };

  const updateMilestoneValue = (functionIndex, imperativeIndex, value) => {
    const updatedValues = [...milestoneValues];
    updatedValues[functionIndex][imperativeIndex] = value;
    setMilestoneValues(updatedValues);
  };
  const [breadcrumbs, setBreadcrumbs] = useState("");
  const [functionItemName, setFunctionItemName] = useState("");
  const [simpItemName, setSimpItemName] = useState("");

  useEffect(() => {
    if (fetchgetChatbot && fetchgetChatbot?.status == 200) {
      if (fetchgetChatbot.message === "chatbot not enabled") {
        setAiButtonEnabled(false);
      } else {
        setAiButtonEnabled(true);
      }
    }
  }, [fetchgetChatbot]);

  useEffect(() => {
    if (getMasterTasksPriorityAndStatusDetails) {
      const transformedStatusOptions =
        getMasterTasksPriorityAndStatusDetails.status_dt.map((status) => ({
          value: status,
          label: status,
        }));
      setStatusData(transformedStatusOptions);
      const transformedPriorityOptions =
        getMasterTasksPriorityAndStatusDetails.priority_dt.map((priority) => ({
          value: priority,
          label: priority,
        }));
      setPriorityData(transformedPriorityOptions);
    }
  }, [getMasterTasksPriorityAndStatusDetails]);

  useEffect(() => {
    if (
      fecthPostDuplicateTasksData &&
      fecthPostDuplicateTasksData.status === 200
    ) {
      if (localStorage.getItem("bi_id") && localStorage.getItem("product_id")) {
        dispatch(
          getXLExecutionPlanDetails(
            localStorage.getItem("bi_id"),
            localStorage.getItem("product_id")
          )
        );
      }
    }
  }, [fecthPostDuplicateTasksData]);

  useEffect(() => {
    if (
      getEmployeeDetails &&
      getEmployeeDetails.emp_data &&
      getEmployeeDetails.emp_data.length > 0
    ) {
      setEmpData(
        getEmployeeDetails.emp_data.map((obj) => {
          return {
            value: obj.id,
            label: obj.prop_name,
            icon: createImageFromInitials(
              30,
              obj.prop_name,
              getRandomColor(obj.prop_name)
            ),
          };
        })
      );
    }
  }, [getEmployeeDetails]);

  useEffect(() => {
    if (localStorage.getItem("bi_id") && localStorage.getItem("product_id")) {
      dispatch(
        getXLExecutionPlanDetails(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id")
        )
      );
    }
    dispatch(getEmployeeData(localStorage.getItem("bi_id")));
    dispatch(getMasterTaskPriorityAndStatusData());
  }, []);

  useEffect(() => {
    if (strategyPlanData) {
      setObjectiveList(strategyPlanData.objective);
      setGoalList(strategyPlanData.goals);
      const updatedFunctionList = strategyPlanData.functions.map(
        (functionItem) => ({
          ...functionItem,
          isCollapsed: false, // Set isCollapsed to false for all items
        })
      );
      const removedGEMSFunctionalGoals = updatedFunctionList.map((item) => ({
        ...item,
        strategic_imperative: item.strategic_imperative.filter(
          (task) => task.is_system_generated_task === false
        ),
      }));

      setFunctionList(removedGEMSFunctionalGoals);
      setMilestoneValues(
        strategyPlanData.functions.map((functionItem) =>
          functionItem.strategic_imperative.map(() => "")
        )
      );
      setDropdownGoalData(
        strategyPlanData.goals.map((goal, i) => {
          return {
            value: goal.id,
            label: goal.label,
          };
        })
      );
    }
  }, [strategyPlanData]);

  useEffect(() => {
    if (selectedBI) {
      setBIName(selectedBI.label);
    }
  }, [selectedBI]);

  useEffect(() => {
    if (goalList.length === 1) {
      setSingleGoal(true);
    } else {
      setSingleGoal(false);
    }
  }, [goalList]);

  useEffect(() => {
    if (postGoalDetails && postGoalDetails.goal_res) {
      const newGoals = postGoalDetails.goal_res
        .filter((goal) => goal.action === "add")
        .map((goal) => ({
          name: goal.goal_name,
          id: goal.id,
          short_name: goal.short_name,
        }));
      setGoalList([...goalList, ...newGoals]);
      setDropdownGoalData((prevData) => [
        ...prevData,
        ...postGoalDetails.goal_res
          .filter((goal) => goal.action === "add")
          .map((goal) => ({
            value: goal.id,
            label: goal.goal_name,
          })),
      ]);
      setDropdownGoalData((prevData) => {
        const updatedGoals = postGoalDetails.goal_res
          .filter((goal) => goal.action === "edit")
          .map((goal) => ({
            value: goal.id,
            label: goal.goal_name,
          }));
        return prevData.map((existingGoal) => {
          const editGoal = updatedGoals.find(
            (goal) => goal.value === existingGoal.value
          );
          return editGoal ? { ...existingGoal, ...editGoal } : existingGoal;
        });
      });

      setDropdownGoalData((prevData) =>
        prevData.filter(
          (goal) =>
            !postGoalDetails.goal_res.some(
              (newGoal) =>
                newGoal.goal_name === goal.label && newGoal.action === "delete"
            )
        )
      );
    }
  }, [isGoalDataFetched, postGoalDetails]);

  useEffect(() => {
    if (postStrategyFunctionDetails && postStrategyFunctionDetails.response) {
      if (postStrategyFunctionDetails.stage_type === "function") {
        postStrategyFunctionDetails.response.forEach((item) => {
          const index = functionList.findIndex((func) => func.id === item.key);
          if (index !== -1) {
            const updatedFunction = {
              ...functionList[index],
              assigned_to: item.assigned_to,
            };
            setFunctionList((prevList) => [
              ...prevList.slice(0, index),
              updatedFunction,
              ...prevList.slice(index + 1),
            ]);
          } else {
            const newFunction = {
              id: item.id,
              assigned_to: item.assigned_to,
            };
            setFunctionList((prevList) => [...prevList, newFunction]);
          }
        });
      }
    }
  }, [postStrategyFunctionDetails]);
  useEffect(
    (isFunctionDataFetched) => {
      if (
        postStrategyFunctionDetails &&
        postStrategyFunctionDetails.response &&
        postStrategyFunctionDetails.action === "add"
      ) {
        if (postStrategyFunctionDetails.stage_type === "function") {
          postStrategyFunctionDetails.response.map((item) => {
            const newFunction = {
              name: item.value,
              id: item.key,
              strategic_imperative: [],
            };
            setFunctionList([...functionList, newFunction]);
          });
        } else if (
          postStrategyFunctionDetails.stage_type === "functional_goal"
        ) {
          postStrategyFunctionDetails.response.map((item) => {
            const newFunctions = [...functionList];
            newFunctions[currentFunctionIndex] &&
              newFunctions[currentFunctionIndex].strategic_imperative.push({
                name: item.value,
                id: item.key,
                status: item.dt_status,
                start_date: item.start_date,
                due_date: item.due_date,
                assigned_to: item.assigned_to,
                priority: item.priority,
                progress: item.progress,
                description: item.description,
                collaberators: item.collaberators,
                goals_dt: item.goals_dt,
                milestones: [],
                user_permission:["write"],
                due_date_perm:"write",
              });
            setFunctionList(newFunctions);
          });
        
        } else if (postStrategyFunctionDetails.stage_type === "milestone") {
          postStrategyFunctionDetails.response.map((item) => {
            const newFunctions = [...functionList];
            newFunctions[currentFunctionIndex] &&
              newFunctions[currentFunctionIndex].strategic_imperative[
                currentImperativeIndex
              ].milestones.push({
                name: item.value,
                id: item.key,
                status: item.dt_status,
                start_date: item.start_date,
                due_date: item.due_date,
                assigned_to: item.assigned_to,
                priority: item.priority,
                progress: item.progress,
                description: item.description,
                collaberators: item.collaberators,
                tasks: [],
              });
            setFunctionList(newFunctions);
          });
        }
      }
    },
    [isFunctionDataFetched, postStrategyFunctionDetails]
  );

  const handleClick = () => {
    navigate("/workboard");
  };
  const handleBack = () => {
    if (
      selectedSubMenuPermission === "write" ||
      selectedSubMenuPermission === "admin"
    ) {
      navigate("/strategyplan");
    } else {
      navigate("/dashboard");
    }
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const openGoalModal = () => {
    setGoalModalIsOpen(true);
  };

  const openFunctionModel = () => {
    setFunctionModel(true);
  };

  const setSimpModel = (functionIndex, value) => {
    setStrategicItems((prev) => ({ ...prev, [functionIndex]: value }));
  };

  const setMilestoneModel = (functionIndex, simpIndex, value) => {
    setMilestoneItems((prev) => ({
      ...prev,
      [functionIndex]: {
        ...prev[functionIndex],
        [simpIndex]: value,
      },
    }));
  };

  const handleObjectveSubmit = (e, id = false) => {
    e.preventDefault();
    if (objectiveData !== "") {
      if (id) {
        // Update the existing item in the list
        dispatch(
          postEditStrategyObjective(
            localStorage.getItem("bi_id"),
            objectiveData
          )
        );
        setObjectiveList((prevList) =>
          prevList.map((item) =>
            item.id === currentItemId ? { ...item, name: objectiveData } : item
          )
        );
      } else {
        // Add a new item to the list
        const newObjective = {
          name: objectiveData,
          id: uuidv4(),
        };
        setObjectiveList([...objectiveList, newObjective]);
      }
    }

    // Clear the currentItemId and exit edit mode
    setCurrentItemId("");
    setEditMode(false);
    setIsObjectiveVisible(false);
    setGoalModalIsOpen(true);
    setIsFunctionVisible(true);
  };

  const handleGoalSubmit = (e) => {
    e.preventDefault();
    if (goalData && goalData.length > 0) {
      if (currentItemId && currentItemId !== "") {
        // Update the existing item in the list
        setGoalList((prevList) =>
          prevList.map((item) =>
            item.id === currentItemId ? { ...item, name: goalData } : item
          )
        );

        dispatch(
          postStrategyGoals([
            {
              goal_dt: goalData,
              goal_id: currentItemId,
              is_active: true,
            },
          ])
        );
      } else {
        dispatch(
          postStrategyGoals([
            {
              bi_id: localStorage.getItem("bi_id"),
              product_id: localStorage.getItem("product_id"),
              goal_dt: goalData,
              is_active: true,
            },
          ])
        );
      }

      if (goalList.length === 1) {
        setSingleGoal(true);
      }

      setCurrentItemId("");
      setGoalModalIsOpen(false);
      setGoalData("");
    }
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      display: "inline-block",
      border: "1px solid #ccc",
      boxSizing: "border-box",
      paddingLeft: 0,
      borderRadius: "10px",
    }),
    img: {
      height: 40,
    },
  };
  const handleFunctionSubmit = (e) => {
    e.preventDefault();
    if (functionData !== "") {
      if (currentItemId && currentItemId !== "") {
        // Update the existing function in the list
        setFunctionList((prevList) =>
          prevList.map((functionItem) =>
            functionItem.id === currentItemId
              ? { ...functionItem, name: functionData }
              : functionItem
          )
        );
        let data = [
          {
            function_id: currentItemId,
            function_name: functionData,
            is_active: true,
          },
        ];
        dispatch(postStrategyFunctions(data, "function", true));
        setEditMode(false);
      } 
      setCurrentItemId("");
      setFunctionData("");
      setFunctionModel(false);
      setIsSimpVisible(true);
    }
  };

  const handleAddStrategicItem = (
    e,
    functionIndex,
    functionId,
    imperative_id = false,
    simpIndex = false
  ) => {
    e.preventDefault();
    setSelectedFunctionIndex(functionIndex);

    if (imperative_id) {
      const newFunctions = [...functionList];
      newFunctions[functionIndex].strategic_imperative[simpIndex].name =
        newStrategicItem;
      let data = [
        {
          imperative_name: newStrategicItem,
          imperative_id: imperative_id,
          is_active: true,
        },
      ];
      dispatch(postStrategyFunctions(data, "functional_goal", false, true));
      setEditMode(false);
      setFunctionList(newFunctions);
    } else {
      setCurrentFunctionIndex(functionIndex);
      let data = [
        {
          bi_id: localStorage.getItem("bi_id"),
          product_id: localStorage.getItem("product_id"),
          function_id: functionId,
          imperative_name: strategicItemValues[functionIndex],
          imperative_id: false,
          status: "Open",
          due_date: "",
          priority: "High",
          assigned_to: "",
          progress: 0,
          description: "",
          collaberators: "",
        },
      ];
      dispatch(postStrategyFunctions(data, "functional_goal", false, true));
    }

    // setNewStrategicItem("");
    updateStrategicItemValue(functionIndex, "");
    setStrategicItems((prev) => ({ ...prev, [functionIndex]: false }));
    setIsSimpVisible(true);
    setIsMilestoneVisible(true);
    setSimpModel(functionIndex, true);
  };

  const handleAddMilestoneItem = (
    e,
    functionIndex,
    simpIndex,
    milestoneIndex = false,
    simpId,
    milestoneId
  ) => {
    e.preventDefault();
    setSelectedFunctionIndex(functionIndex);

    if (currentItemId && currentItemId !== "") {
      const newFunctions = [...functionList];
      newFunctions[functionIndex].strategic_imperative[simpIndex].milestones[
        milestoneIndex
      ].name = newMilestoneItem; // Update the milestone name
      setEditMode(false);
      let data = [
        {
          milestone: newMilestoneItem,
          milestone_id: milestoneId,
          is_active: true,
        },
      ];
      dispatch(postStrategyFunctions(data, "milestone", false, false, true));
      setFunctionList(newFunctions);
    } else {
      setCurrentFunctionIndex(functionIndex);
      setCurrentImperativeIndex(simpIndex);
      let data = [
        {
          imperative_id: simpId,
          milestone: milestoneValues[functionIndex][simpIndex],
          milestone_id: false,
          status: "Open",
          start_date: "",
          due_date: "",
          priority: "High",
          assigned_to: "",
          progress: 0,
          description: "",
          collaberators: "",
        },
      ];
      dispatch(postStrategyFunctions(data, "milestone", false, false, true));
    }
    setCurrentItemId("");

    setMilestoneItems((prev) => ({
      ...prev,
      [functionIndex]: { ...prev[functionIndex], [simpIndex]: false },
    }));
    setMilestoneModel(functionIndex, simpIndex, true);
    setIsMilestoneVisible(true);

    setNewMilestoneItem("");
    updateMilestoneValue(functionIndex, simpIndex, "");
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setEditMode(false);
        setGoalModalIsOpen(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleGoalKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "s") {
      e.preventDefault();
      handleGoalSubmit(e);
    } else if (e.key === "Escape") {
      setEditMode(false);
      setGoalModalIsOpen(false);
    }
  };

  const handleObjectiveKeyDown = (e, itemid) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "s") {
      e.preventDefault();
      handleObjectveSubmit(e, itemid);
    } else if (e.key === "Escape") {
      setEditMode(false);
      setGoalModalIsOpen(false);
    }
  };
  
 const handleAllCollapseToggle = () => {
  setFunctionList((prevFunctionList) => {
    const shouldCollapseAll = !prevFunctionList.every(
      (func) => func.isCollapsed
    );

    return prevFunctionList.map((func) => ({
      ...func,
      isCollapsed: shouldCollapseAll,
    }));
  });
};


  const handleCollapseToggle = (functionIndex) => {
    setFunctionList((prevFunctionList) => {
      const newList = [...prevFunctionList];
      newList[functionIndex].isCollapsed = !newList[functionIndex].isCollapsed; // Toggle the collapse state for the specific function
      return newList;
    });
  };

  const handleCollapseToggleSimp = (simpIndex) => {
    setCollapsedItems((prevCollapsedItems) => ({
      ...prevCollapsedItems,
      [simpIndex]: !prevCollapsedItems[simpIndex],
    }));
  };

  // popup close and open
  const handlePopupClose = () => {
    setShowGoalPopup(false);
  };

  const handlePopupShow = () => {
    setShowGoalPopup(true);
  };

  const handleEditClick = (action, name, id) => {
    if (action == "objective") {
      setObjectiveData(name);
    } else if (action == "goal") {
      setGoalData(name);
    } else if (action == "function") {
      setFunctionData(name);
    } else if (action == "strategicItem") {
      setNewStrategicItem(name);
    } else if (action == "milestone") {
      setNewMilestoneItem(name);
    }
    setCurrentItemId(id);
    setEditMode(true);
    setShowIcons(false);
  };

  const handleGoalDelete = (itemId) => {
    const updatedList = goalList.filter((item) => item.id !== itemId);
    setGoalList(updatedList);
    dispatch(
      postStrategyGoals([
        {
          bi_id: localStorage.getItem("bi_id"),
          product_id: localStorage.getItem("product_id"),
          goal_id: itemId,
          is_active: false,
        },
      ])
    );
  };

  const handleEditPopup = () => {
    setEditPopupShow(true);
  };
  const handleEditPopupClose = () => {
    setEditPopupShow(false);
  };

  const handleDeleteFunction = (itemId) => {
    const updatedList = functionList.filter((item) => item.id !== itemId);
    setFunctionList(updatedList);
    let data = [
      {
        function_id: itemId,
        is_active: false,
      },
    ];
    dispatch(postStrategyFunctions(data, "function", true));
  };

  const handleStrategicImpDelete = (functionIndex, simpIndex, simpId) => {
    Alert.warning({
      title:
        "Deleting a Functional Goal or Milestone or Parent Task will also delete all of its milestones and tasks and sub-tasks.",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      preConfirm: (isConfirm) => {
        if (isConfirm) {
          let data = [
            {
              imperative_id: simpId,
              is_active: false,
            },
          ];
          const newFunctions = [...functionList];
          newFunctions[functionIndex].strategic_imperative.splice(simpIndex, 1);
          setFunctionList(newFunctions);
          dispatch(postStrategyFunctions(data, "functional_goal", false, true));
          dispatch(resetExceptionError());
        } else {
        }
      },
    });
  };

  const handleStrategicImpEdit = (
    functionIndex,
    simpIndex,
    data,
    updatedAssignedData,
    updatedGoalsData,
    updatedCollaboratorsData
  ) => {
    const newFunctions = [...functionList];
    const existingStrategicImp =
      newFunctions[functionIndex].strategic_imperative[simpIndex];

    newFunctions[functionIndex].strategic_imperative[simpIndex] = {
      ...existingStrategicImp,
      name: data[0].imperative_name,
      status: data[0].status,
      start_date:data[0].start_date,
      due_date: data[0].due_date,
      priority: data[0].priority,
      assigned_to: updatedAssignedData,
      progress: data[0].progress,
      description: data[0].description,
      collaberators: updatedCollaboratorsData,
      goals_dt: updatedGoalsData,
    };

    dispatch(postStrategyFunctions(data, "functional_goal", false, true));
    setFunctionList(newFunctions);
  };

  const handleMilestoneDelete = (
    functionIndex,
    simpIndex,
    milestoneIndex,
    milestoneId
  ) => {
    Alert.warning({
      title:
        "Deleting a Functional Goal or Milestone or Parent Task will also delete all of its milestones and tasks and sub-tasks.",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      preConfirm: (isConfirm) => {
        if (isConfirm) {
          const newFunctions = [...functionList];
          newFunctions[functionIndex].strategic_imperative[
            simpIndex
          ].milestones.splice(milestoneIndex, 1);
          setFunctionList(newFunctions);
          let data = [
            {
              milestone_id: milestoneId,
              is_active: false,
            },
          ];
          dispatch(
            postStrategyFunctions(data, "milestone", false, false, true)
          );
          dispatch(resetExceptionError());
        } else {
        }
      },
    });
  };

  const handleMilestoneEdit = (
    functionIndex,
    simpIndex,
    milestoneIndex,
    data,
    updatedAssignedData
  ) => {
    const newFunctions = [...functionList];
    const existingMilestone =
      newFunctions[functionIndex].strategic_imperative[simpIndex].milestones[
        milestoneIndex
      ];

    newFunctions[functionIndex].strategic_imperative[simpIndex].milestones[
      milestoneIndex
    ] = {
      ...existingMilestone,
      name: data[0].milestone,
      status: data[0].status,
      start_date: data[0].start_date,
      due_date: data[0].due_date,
      priority: data[0].priority,
      assigned_to: updatedAssignedData,
      progress: data[0].progress,
      description: data[0].description,
      collaberators: data[0].collaberators,
    };

    dispatch(postStrategyFunctions(data, "milestone", false, false, true));
    setFunctionList(newFunctions);
  };

  const handleVerticalIconClick = () => {
    setOnElipsisshowIcons(true);
  };
  const handleVerticalIconMouseLeave = () => {
    setOnElipsisshowIcons(false);
  };

  const handleSidebar = (
    is_edit,
    data,
    placeholder,
    type,
    selectedItem,
    functionIndex,
    simpIndex,
    breadcrumbs,
    milestoneIndex,
    userperm,
    user_due_date_perm,
    functionItemName = "",
    simpItemName = ""
  ) => {
    if (userperm === "write") {
      setUserPermission(userperm);
    } else if (userperm === "read") {
      setUserPermission(userperm);
    }
    setUserDueDatePermission(user_due_date_perm);
    setIsSidebarOpen(true);
    setIsEdit(is_edit);
    setSelectedData(data);
    setSidebarType(type);
    setPlaceholder(placeholder);
    setSelectedItemId(selectedItem);
    setCurrentFunctionIndex(functionIndex);
    setFunctionItemName(functionItemName);
    setSimpItemName(simpItemName);
    if (simpIndex !== false) {
      setCurrentImperativeIndex(simpIndex);
    }
    if (is_edit && milestoneIndex !== false) {
      setCurrentMilestoneIndex(milestoneIndex);
    }
    setBreadcrumbs(breadcrumbs);
  };
  const handleOwnerCancliClick = () => {
    setAssignOwnerClick(false);
    setCurrentFunctionId("");
  };

  const handleshowAiGenerateOpen = () => {
    setShowAiGenerate(true);
  };
  const handleshowAiGenerateClose = () => setShowAiGenerate(false);

  const handleAiEdit = () => {
    setAiEdit(false);
    setShowAiGenerate(false);
    dispatch({ type: RESET_AI_GENERATED_GOALS });
    setTimeout(() => {
      setGoals([]);
    }, 300);
  };


  useEffect(() => {
    if (aiGeneratedGoals?.tasks_json?.length > 0 && !aiEdit){
      setGoals(aiGeneratedGoals.tasks_json);

      setAiEdit(true);
    }
  }, [aiGeneratedGoals]);

  useEffect(() => {
    if (fetchPostCreateAiGeneratedGoals && fetchPostCreateAiGeneratedGoals?.status === 'Success'){
      window.location.reload()
      handleAiEdit()
      setTimeout(() => {setAiFullScreenMode(false);
        }, 1000);
    }
  }, [fetchPostCreateAiGeneratedGoals]);

  const [treeView, setTreeView] = useState(false);

  const handleTreeViewOpen = (e) => {
    setTreeView(true)
  }

  const handleTreeViewClose = (e) => {
    setTreeView(false)
  }
  

  


  const GeneratePanel = ({ handleshowAiGenerateClose, aiFunctionName }) => {
    // Move all the specific generation states here
    const [prompt, setPrompt] = useState("");
    const [haveFg, setHaveFg] = useState(false);
    const [fg, setFg] = useState("");
    const [fgCount, setFgCount] = useState("4");
    const [msCount, setMsCount] = useState("2-5");

    const fgOptions = [1, 2, 3, 4, 5, 6, 7, 8].map((n) => ({
    value: String(n),
    label: String(n),
    }));

    const msOptions = [
      { value: "2-5", label: "2 - 5" },
      { value: "3-6", label: "3 - 6" },
      { value: "5-7", label: "5 - 7" },
    ];

    const handleAiSubmit = (event) => {
      event.preventDefault();
      

      const bi_id = localStorage.getItem("bi_id");
      const product_id = localStorage.getItem("product_id");

      if (bi_id && product_id) {

        dispatch(getAiGeneratedGoals(bi_id, product_id, prompt, haveFg , fg, fgCount, msCount, aiFunctionName));
  
      }
      };
    
    return (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            // marginBottom: "20px",
            borderBottom: "1px solid lightGray",
            padding: "0 20px",
          }}
        >
          <div
            style={{
              fontSize: "var(--text-font-size)",
              fontWeight: "var(--heading-font-weight)",
            }}
          >
            Generate Functional Goals & Milestones
          </div>
          <div style={{ display: "flex", justifyContent: "end", gap: "20px" }}>
            <Button
              form="ai-form"
              type="submit"
              style={{
                backgroundColor: "var(--button-primary-color)",
                width: "fit-content",
              }}
            >
              Generate
            </Button>

            <button
              style={{
                border: "none",
                // borderRadius: "20px",
                // backgroundColor: "white",
                background: "none",
                fontSize: "36px",
                // marginBottom: "10px",
              }}
              onClick={() => {
                handleshowAiGenerateClose();
              }}
            >
              &times;
            </button>
          </div>
        </div>

        {/* Content */}
        <form
          id="ai-form"
          style={{ padding: "20px" , flexGrow:'1',
            overflowY:'auto',
            overflowX:'hidden',
            paddingBottom:'100px'}}
          onSubmit={(event) => handleAiSubmit(event)}
        >
          <div sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            <div className="ai-instructions">
              <div className="ai-instructions-title">
                How the AI will generate functional goals and milestones
              </div>

              <div className="ai-instructions-text">
                Add optional context to help the AI produce  goals and milestones aligned with your needs.
              </div>

              <ul className="ai-instructions-list">
                <li>Specify key priorities such as security, compliance, or risk management</li>
                <li>Include expectations around scale, performance, or delivery timelines</li>
                <li>Define the desired level of detail and professional tone</li>
              </ul>
            </div>
            <div><div
              style={{
                marginBottom: "5px",
                marginRight: "20px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Provide any additional instructions or requirements for AI:
            </div>
            <TextField
              name="prompt"
              // label="Describe what you want to generate..."
              multiline
              rows={10}
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              fullWidth
            /></div>
            

            <span>
              <Checkbox checked={haveFg} onChange={() => setHaveFg(!haveFg)} />
              I already have functional goals defined
            </span>

            {haveFg && (
              <>
                <div
              style={{
                marginBottom: "5px",
                marginRight: "20px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Describe your functional goals: 
            </div>
                <TextField
                  name="fg"
                  // label="Describe what you want to generate..."
                  required={haveFg}
                  multiline
                  rows={5}
                  value={fg}
                  onChange={(e) => setFg(e.target.value)}
                  fullWidth
                />
            
              </>
            )}

            {!haveFg && (
              <div>
                <div
              style={{
                marginBottom: "5px",
                marginRight: "20px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              How many functional goals should be created:
            </div>
                {" "}
                {/* <AiSelect
                  value={fgCount}
                  onChange={(e) => setFgCount(e.target.value)}
                  sx={{
                    height: "30px",
                    width: "120px",
                    textAlign: "center",
                  }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                    <MenuItem key={n} value={String(n)}>
                      {n}
                    </MenuItem>
                  ))}
                </AiSelect> */}
                <Select
                  required
                  className="fg-select"
                  placeholder={
                    <span style={{ fontSize: "var(--text-font-size)" }}>
                      Select FG Count
                    </span>
                  }
                  value={fgOptions.find((opt) => opt.value === fgCount)}
                  options={fgOptions}
                  onChange={(selected) => setFgCount(selected.value)}
                  getOptionLabel={(e) => (
                    <div style={{ display: "flex", alignItems: "center", cursor:'pointer' }}>
                      <span
                        style={{
                          marginLeft: 5,
                          fontSize: "var(--sub-heading-font-size)",
                        }}
                      >
                        {e.label}
                      </span>
                    </div>
                  )}
                />
              </div>
            )}

            <div style={{marginBottom:'200px'}} >
              <div
              style={{
                marginBottom: "5px",
                marginRight: "20px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              How many milestones should be created for each functional goal:
            </div>
               {"  "}
              <Select
                required
                className="ms-select"
                placeholder={
                  <span style={{ fontSize: "var(--text-font-size)" }}>
                    Select MS Count
                  </span>
                }
                value={msOptions.find((opt) => opt.value === msCount) || null}
                options={msOptions}
                onChange={(selected) => setMsCount(selected.value)}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        marginLeft: 5,
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
              />
            </div>

            
          </div>
        </form>
      </>
    );
};



  const content = (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      {treeView && <TreeView open={treeView} handleTreeViewClose={handleTreeViewClose} />}
      <Drawer
        sx={{
          "& .MuiDrawer-paper": {
            width: "50%",
            // padding: 2,
            height: "calc(100vh-63px)",
            marginTop: "64px",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "transparent",
            },
          },
        }}
        PaperProps={{
          sx: {
            boxShadow: "none",
            borderLeft: "1px solid lightGray",
          },
        }}
        anchor="right"
        transitionDuration={{ enter: 500, exit: 300 }}
        SlideProps={{
          easing: {
            enter: "cubic-bezier(0.0, 0, 0.2, 1)", // standard
            exit: "cubic-bezier(0.4, 0.0, 1, 1)", // ease-out
          },
        }}
        open={showAiGenerate}
        onClose={handleshowAiGenerateClose}
      >
        {/* Header */}
        <GeneratePanel 
          handleshowAiGenerateClose={handleshowAiGenerateClose}
          aiFunctionName={aiFunctionName} />
        
      </Drawer>

      <Drawer
        anchor="right"
        open={aiEdit}
        onClose={handleAiEdit}
        transitionDuration={{ enter: 500, exit: 300 }}
        SlideProps={{
          easing: {
            enter: "cubic-bezier(0.0, 0, 0.2, 1)", // standard
            exit: "cubic-bezier(0.4, 0.0, 1, 1)", // ease-out
            transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
          },
        }}
        PaperProps={{
          sx: {
            boxShadow: "none",
            borderLeft: "1px solid lightGray",
          },
        }}
        sx={{
          "& .MuiDrawer-paper": {
            // width: aiFullScreenMode ? 'calc(100% - 50px)' : '50%',
            // transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
            padding: 0,
            height: "calc(100vh - 50px)",
            marginTop: "64px",
            width: aiFullScreenMode ? "calc(100% - 50px)" : "50%",
            // paddingBottom: "64px",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "transparent",
            },
          },
        }}
      >
        <AiEditDrawer
          goals={goals}
          handleAiEdit={handleAiEdit}
          // updateGoal={updateGoal}
          // updateMilestone={updateMilestone}
          aiFullScreenMode={aiFullScreenMode}
          setAiFullScreenMode={setAiFullScreenMode}
          dispatch={dispatch}
          aiFunctionId={aiFunctionId}
        />
      </Drawer>

      <div style={{ paddingRight: "10px" }}>
        <div className="d-flex align-items-center biname">
          <img src={Goals} width={"24px"} style={{ marginLeft: "10px" }} />
          <span style={{ paddingLeft: "5px" }}>
            <div
              style={{
                fontSize: "var(--main-heading)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              {biName}
            </div>
          </span>
        </div>
      </div>
      <div>
        <form>
          {objectiveList && objectiveList.length === 0 ? (
            <div
              style={{
                display: isobjectiveVisible ? "flex" : "none",
                alignItems: "center",
                width: "100%",
              }}
            >
              {(selectedSubMenuPermission === "write" ||
                selectedSubMenuPermission === "admin") && (
                <div
                  style={{
                    display: !ModalIsOpen ? "flex" : "none",
                    width: "100%",
                  }}
                >
                  <button
                    className="buttonStyle"
                    type="button"
                    onClick={openModal}
                    style={{
                      color: "#0a5f59",
                      fontSize: "var(--sub-heading-font-size)",
                    }}
                  >
                    <img
                      src={AddColorIcon}
                      width={16}
                      height={16}
                      style={{ marginRight: "5px" }}
                    />
                    Add Objective
                  </button>
                </div>
              )}
              <div
                className="ObjectInput"
                style={{ display: ModalIsOpen ? "flex" : "none" }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "50%",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                  }}
                >
                  <InputField
                    onChange={(e) => setObjectiveData(e.target.value)}
                    Close={(e) => setModalIsOpen(false)}
                    handleSubmit={(e) => handleObjectveSubmit(e, false)}
                    placeholder="Name your objective"
                    name="objective"
                    handleKeyDown={(e) => handleObjectiveKeyDown(e, false)}
                  />
                </div>
                <div>
                  <AddExistingpopup
                    Title="Add Existing Objective"
                    ModalTitle="My objective library"
                    handleClose={() => handlePopupClose()}
                    show={show}
                    AddFolder={AddFolder}
                    handleShow={() => handlePopupShow()}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div>
              {objectiveList.map((item, index) => (
                <>
                  <div key={index}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        position: "relative",
                        paddingRight: "10px",
                      }}
                      onMouseEnter={() => setShowIcons(item.id)}
                      onMouseLeave={() => setShowIcons(null)}
                    >
                      <div
                        className="Objective"
                        style={{ wordWrap: "break-word" }}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{ paddingTop: "10px" }}
                        >
                          <img
                            src={Objective}
                            width={"24px"}
                            style={{ marginLeft: "10px" }}
                          />
                          <span
                            style={{
                              paddingLeft: "5px",
                              fontSize: "var(--sub-heading-font-size)",
                            }}
                          >
                            Objective
                          </span>
                        </div>
                        {/* Display the objective name */}
                        {/* edit option here for objective */}
                        {editMode && item.id === currentItemId ? (
                          <div style={{ width: "80%" }}>
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                marginLeft: "40px",
                                marginBottom: "6px",
                              }}
                            >
                              <InputField
                                value={objectiveData}
                                onChange={(e) =>
                                  setObjectiveData(e.target.value)
                                }
                                handleSubmit={(e) =>
                                  handleObjectveSubmit(e, item.id)
                                }
                                Close={() => setEditMode(false)}
                                handleKeyDown={(e) =>
                                  handleObjectiveKeyDown(e, item.id)
                                }
                              />
                            </div>
                          </div>
                        ) : (
                          <div style={{ display: "flex", width: "100%" }}>
                            <div
                              className="ObjectiveData"
                              style={{
                                width: "100%",
                                paddingBottom: "10px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                wordWrap: "break-word",
                                textOverflow: "ellipsis",
                                transition: "text-overflow 0.3s",
                                fontSize: "var(--text-font-size)",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.width = "100%";
                                e.target.style.whiteSpace = "normal";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.width = "100%";
                                e.target.style.whiteSpace = "nowrap";
                              }}
                            >
                              {item.name}

                              {/* edit remove component */}
                            </div>
                            {(selectedSubMenuPermission === "write" ||
                              selectedSubMenuPermission === "admin") && (
                              <ManageOptions
                                handleEditClick={() =>
                                  handleEditClick(
                                    "objective",
                                    item.name,
                                    item.id
                                  )
                                }
                                handleDeleteClick={() => {}}
                                showIcons={showIcons === item.id}
                                showDelete={false}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* add goal */}
                  {goalList && goalList.length > 0 && (
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                      }}
                    >
                      {goalList.map((item, index) => (
                        <div
                          key={item.id}
                          className="goal"
                          style={{ width: singleGoal ? "100%" : "49%" }}
                        >
                          <div
                            style={{
                              position: "relative",
                              alignItems: "center",
                            }}
                            onMouseEnter={() => setShowIcons(item.id)}
                            onMouseLeave={() => setShowIcons(null)}
                          >
                            <div style={{ wordWrap: "break-word" }}>
                              <div
                                className="d-flex align-items-center"
                                style={{ paddingTop: "10px" }}
                              >
                                <img
                                  src={Goals}
                                  width={"24px"}
                                  style={{ marginLeft: "10px" }}
                                />
                                <span
                                  style={{
                                    paddingLeft: "5px",
                                    fontSize: "var(--sub-heading-font-size)",
                                  }}
                                >
                                  Goal ({item.short_name})
                                </span>
                              </div>
                            </div>
                            {/* editing the goal item and submit */}
                            {editMode && item.id === currentItemId ? (
                              <div style={{ width: "90%" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "space-evenly",
                                    alignItems: "center",
                                    marginLeft: "40px",
                                  }}
                                >
                                  <InputField
                                    value={goalData}
                                    onChange={(e) =>
                                      setGoalData(e.target.value)
                                    }
                                    handleKeyDown={handleGoalKeyDown}
                                    handleSubmit={(e) => handleGoalSubmit(e)}
                                    Close={() => setEditMode(false)}
                                  />
                                </div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <div
                                  className="ObjectiveData"
                                  style={{
                                    width: "70%",
                                    paddingBottom: "10px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    wordWrap: "break-word",
                                    textOverflow: "ellipsis",
                                    transition: "text-overflow 0.3s",
                                    fontSize: "var(--text-font-size)",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.width = "100%";
                                    e.target.style.whiteSpace = "normal";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.width = "70%";
                                    e.target.style.whiteSpace = "nowrap";
                                  }}
                                >
                                  {item.name}
                                </div>
                                {/* edit remove component */}
                                {(selectedSubMenuPermission === "write" ||
                                  selectedSubMenuPermission === "admin") && (
                                  <ManageOptions
                                    handleEditClick={() =>
                                      handleEditClick(
                                        "goal",
                                        item.name,
                                        item.id
                                      )
                                    }
                                    handleDeleteClick={() =>
                                      handleGoalDelete(item.id)
                                    }
                                    showIcons={showIcons === item.id}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div
                    style={{
                      display: isGoalVisible ? "flex" : "none",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {(selectedSubMenuPermission === "write" ||
                      selectedSubMenuPermission === "admin") && (
                      <div
                        style={{
                          display: !GoalModalIsOpen ? "flex" : "none",
                          width: "100%",
                        }}
                      >
                        <button
                          className="buttonStyle"
                          type="button"
                          onClick={openGoalModal}
                          style={{
                            color: "#0a5f59",
                            fontSize: "var(--sub-heading-font-size)",
                          }}
                        >
                          <img src={AddColorIcon} width={16} height={16} />
                          <span style={{ paddingLeft: "5px" }}>Add Goal</span>
                        </button>
                      </div>
                    )}
                    <div
                      className="ObjectInput"
                      style={{ display: GoalModalIsOpen ? "flex" : "none" }}
                    >
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          justifyContent: "space-evenly",
                          alignItems: "center",
                        }}
                      >
                        <InputField
                          onChange={(e) => setGoalData(e.target.value)}
                          Close={(e) => setGoalModalIsOpen(false)}
                          handleSubmit={(e) => handleGoalSubmit(e)}
                          placeholder="Enter your goal"
                          name="goal"
                          handleKeyDown={handleGoalKeyDown}
                        />
                      </div>
                      {/* add existing popup here */}
                      <div>
                        <AddExistingpopup
                          Title="Add Existing Goal"
                          ModalTitle="My Goal Library"
                          handleClose={() => handlePopupClose()}
                          show={showGoalPopup}
                          AddFolder={AddFolder}
                          handleShow={() => handlePopupShow()}
                          stage={"goals"}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          )}

          {functionList && functionList.length > 0 ? (
            <>
              <div className="xl-ex-guide-text">
                <label>
                  First, add functional goals for each function, then add
                  milestones for each functional goal.
                </label>
                <div className="collapse-toggle">
                  <span>
                    {functionList.every((func) => func.isCollapsed)
                      ? <span style={{fontWeight:'600'}}>Expand All</span>
                      : <span style={{fontWeight:'600'}}>Expand All</span>}
                  </span>

                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={functionList.every((func) => func.isCollapsed)}
                      onChange={handleAllCollapseToggle}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              </div>
              <div style={{ marginTop: "10px" }}>
                {functionList.map((functionItem, functionIndex) => (
                  <div key={functionIndex} style={{ marginBottom: "10px" }}>
                    <div>
                      {editMode && functionItem.id === currentItemId ? (
                        <div style={{ width: "80%" }}>
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "space-evenly",
                              alignItems: "center",
                              marginLeft: "40px",
                              marginBottom: "6px",
                            }}
                          >
                            <InputField
                              value={functionData}
                              onChange={(e) => setFunctionData(e.target.value)}
                              handleSubmit={(e) =>
                                handleFunctionSubmit(e, functionItem.id)
                              }
                              Close={() => setEditMode(false)}
                            />
                          </div>
                        </div>
                      ) : (
                        <div
                          className="d-flex align-items-center"
                          style={{
                            padding: "5px",
                            backgroundColor:
                              currentFunctionId === functionItem.id
                                ? "#D9F6E4"
                                : "transparent",
                          }}
                        >
                          <img
                            src={Arrow}
                            width={"24px"}
                            style={{
                              cursor: "pointer",
                              transition: "transform 0.3s ease",
                              transform: functionItem.isCollapsed
                                ? "rotate(180deg)"
                                : "rotate(0)",
                            }}
                            onClick={() => handleCollapseToggle(functionIndex)}
                          />
                          <button
                            style={{
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              padding: "2px 8px 4px 8px",
                              marginLeft: "8px",
                              fontSize: "var(--sub-heading-font-size)",
                              textWrap: "nowrap",
                            }}
                            className={`color${(functionIndex % 3) + 1}`}
                            type="button"
                            onClick={() => handleCollapseToggle(functionIndex)}
                          >
                            {functionItem.name}
                          </button>

                          <div style={{ marginLeft: "10px" }}>
                            {/* <button
                            type="button"
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                            }}
                          >
                            <img src={ProfileAdd} width={20} />
                          </button> */}
                            <button
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={(e) =>
                                handleAssignOwnerClick(e, functionItem.id)
                              }
                              
                              disabled={
                             
                              selectedSubMenuPermission === "admin"? false:true }
                             
                            >
                              {functionItem.assigned_to &&
                              functionItem.assigned_to.length > 0 &&
                              functionItem.assigned_to.find(
                                (j) => j.is_active
                              ) ? (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-${
                                        functionItem.assigned_to.find(
                                          (j) => j.is_active
                                        ).label
                                      }`}
                                    >
                                      {
                                        functionItem.assigned_to.find(
                                          (j) => j.is_active
                                        ).label
                                      }
                                    </Tooltip>
                                  }
                                >
                                      <div style={{
                                        position: "relative",
                                        display: "inline-block",
                                        // margin: "10px",
                                      }}>
                                        <img
                                          alt="owner"
                                          src={createImageFromInitials(
                                            30,
                                            functionItem.assigned_to.find(
                                              (j) => j.is_active
                                            ).label,
                                            getRandomColor(
                                              functionItem.assigned_to.find(
                                                (j) => j.is_active
                                              ).label
                                            )
                                          )}
                                        />
                                        {(functionItem.assigned_to.find((item) => item.is_active)?.status === "Inactive" || functionItem.assigned_to.find((item) => item.is_active)?.bi_mapping === false) && (
                                          <TiDelete
                                            size={14}
                                            style={{
                                              position: "absolute",
                                              bottom: "0px",
                                              right: "0px",
                                              background: "#fff",
                                              borderRadius: "50%",
                                              color: "#DC2626",
                                              padding: "1px",
                                            }}
                                          />
                                        )}
                                      </div>
                                    </OverlayTrigger>
                              ) : (
                                <img alt="" src={ProfileAdd} />
                              )}
                            </button>
                          </div>
                          {AssingOwnerClick && (
                            <motion.div
                              initial={{ x: "100%" }}
                              animate={{ x: 1 }}
                              exit={{ x: "100%" }}
                              style={{
                                boxShadow:
                                  "-5px 0px 12px -15px  rgba(0, 0, 0,  0.3)",
                              }}
                              className={"sidenav"}
                            >
                              <div
                                className="gtm-sidebar-header"
                                style={{
                                  borderBottom: "1px solid lightgrey",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "var(--sub-heading-font-size)",
                                    fontWeight: "var(--heading-font-weight)",
                                  }}
                                >
                                  Assign Owner for Function
                                </div>
                                <a
                                  href="#"
                                  className="closebtn"
                                  onClick={() => {
                                    handleOwnerCancliClick();
                                  }}
                                >
                                  &times;
                                </a>
                              </div>
                              <div className="gtm-sidebar-body">
                                <div className="row">
                                  <div
                                    className="col-6"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "10px",
                                      zIndex: 2000,
                                    }}
                                  >
                                    <h6 style={{ marginRight: "10px" }}>
                                      Owner
                                    </h6>
                                    <Select
                                      name="emp_id"
                                      styles={customStyles}
                                      className="form-control selectr"
                                      placeholder={
                                        <span
                                          style={{
                                            fontSize: "var(--text-font-size)",
                                          }}
                                        >
                                          Assign owner for function
                                        </span>
                                      }
                                      value={selectedOption}
                                      options={empData}
                                      onChange={handleChange}
                                      isSearchable={true}
                                      filterOption={customFilter}
                                      getOptionLabel={(e) => (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          <img alt="" src={e.icon} />
                                          <span
                                            style={{
                                              marginLeft: 5,
                                              fontSize: "var(--text-font-size)",
                                            }}
                                          >
                                            {e.label}
                                          </span>
                                        </div>
                                      )}
                                      components={{
                                        DropdownIndicator: () => null,
                                        IndicatorSeparator: () => null,
                                        // Option: EmpIconOption,
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <Button
                                      className="save-button-style-rhpo"
                                      onClick={(e) => handleOwnerSubmit(e)}
                                    >
                                      Save
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </motion.div>
                          )}
                        
                            {(selectedSubMenuPermission === "admin" &&
                            <div
                              className="ElipsisVerticalIcon"
                              onClick={() => {
                                handleVerticalIconClick();
                              }}
                              onMouseLeave={handleVerticalIconMouseLeave}
                            >
                              <img
                                src={ElipsisVerticalIcon}
                                width={"4px"}
                                alt="Ellipsis Vertical Icon"
                              />
                              {onElipsisshowIcons && (
                                <div className="IconsContainer">
                                  <div className="ElipsisEditIcon">
                                    <button
                                      type="button"
                                      className="Addobjstyle"
                                      style={{
                                        display: "flex",
                                      }}
                                      onClick={() =>
                                        handleEditClick(
                                          "function",
                                          functionItem.name,
                                          functionItem.id
                                        )
                                      }
                                    >
                                      <img
                                        src={EditIcon}
                                        width={"18px"}
                                        alt="Edit Icon"
                                      />
                                      <span style={{ paddingLeft: "10px" }}>
                                        Edit
                                      </span>
                                    </button>
                                  </div>
                                  {/* {selectedSubMenuPermission === "admin" && (
                                  <div
                                    className="ElipsisDeleteIcon"
                                    onClick={() =>
                                      handleDeleteFunction(functionItem.id)
                                    }
                                  >
                                    <img
                                      style={{ opacity: ".7" }}
                                      src={DeleteIcon}
                                      width={"24px"}
                                      alt="Delete Icon"
                                    />
                                    <span style={{ paddingLeft: "10px" }}>
                                      Delete
                                    </span>
                                  </div>
                                )} */}
                                </div>
                              )}
                            </div>
                          )}
                          <div
                            style={{
                              display: issimpVisible ? "block" : "none",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            {(selectedSubMenuPermission === "write" ||
                              selectedSubMenuPermission === "admin") &&
                              functionItem.user_permission === "write" && (
                                <div
                                  style={{
                                    display: strategicItems[functionIndex]
                                      ? "none"
                                      : "flex",
                                    width: "100%",
                                  }}
                                >
                                  <button
                                    className="buttonStyle"
                                    style={{
                                      color: "#0a5f59",
                                      fontSize: "var(--sub-heading-font-size)",
                                    }}
                                    type="button"
                                    // onClick={() => setSimpModel(functionIndex, false)}
                                    onClick={() => {
                                      handleSidebar(
                                        false,
                                        false,
                                        "Write a functional goal name",
                                        "functional_goal",
                                        functionItem.id,
                                        functionIndex,
                                        false,
                                        functionItem.name +
                                          " > New Functional Goal",
                                        false,
                                        functionItem?.user_permission,
                                        functionItem.name,
                                        ""
                                      );
                                      setCurrentImperativeId("");
                                      setCurrentMilestoneId("");
                                      setCurrentFunctionId(functionItem.id);
                                    }}
                                  >
                                    <img
                                      src={AddColorIcon}
                                      width={16}
                                      height={16}
                                      style={{ marginRight: "5px" }}
                                    />
                                    Add Functional Goal
                                  </button>
                                  {aiButtonEnabled && <button
                                    className="ai-button"
                                    type="button"
                                    // onClick={() => setSimpModel(functionIndex, false)}
                                    onClick={() => {
                                      handleshowAiGenerateOpen();
                                      setAiFunctionId(functionItem.id);
                                      setAiFunctionName(functionItem.name);
                                    }}
                                  >
                                    {/* <img
                                      src={ChatIcon}
                                      width={40}
                                      height={40}
                                      style={{ marginTop:'3px' }}
                                    /> */}
                                    <span className="ai-button-icon" >
                                      <svg width="0" height="0">
                                        <defs>
                                          <linearGradient id="aiIconGradient" gradientTransform="rotate(90)">
                                            <stop offset="0%" stopColor="#A47CF3" />
                                            <stop offset="100%" stopColor="#683FEA" />
                                          </linearGradient>
                                        </defs>
                                      </svg>
                                      <HiSparkles size={20}/>
                                    </span>
                                    
                                    <span className="ai-button-text" >Generate with AI</span>
                                    
                                  </button>}
                                </div>
                              )}
                            {/* <div
                          className="ObjectInput"
                          style={{
                            display: strategicItems[functionIndex]
                              ? "none"
                              : "none",
                            marginLeft: "40px",
                            width: "96%",
                            marginRight: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              marginLeft: "40px",
                              width: "50%",
                              justifyContent: "space-evenly",
                              alignItems: "center",
                            }}
                          >
                            <InputField
                              onChange={(e) =>
                                updateStrategicItemValue(
                                  functionIndex,
                                  e.target.value
                                )
                              }
                              Close={() => setSimpModel(functionIndex, true)}
                              // value={newStrategicItem}
                              value={strategicItemValues[functionIndex]}
                              handleSubmit={(e) =>
                                handleAddStrategicItem(
                                  e,
                                  functionIndex,
                                  functionItem.id
                                )
                              }
                              placeholder="Add Functional Goal here"
                              name="strategic"
                            />
                          </div>
                          <div style={{ display: "none" }}>
                            <AddExistingpopup
                              Title="Add Existing Functional Goal"
                              ModalTitle="My Functional Goal Library"
                              handleClose={() => handlePopupClose()}
                              show={showSimpPopup}
                              AddFolder={AddFolder}
                              handleShow={() => handlePopupShow()}
                            />
                          </div>
                        </div> */}
                          </div>
                        </div>
                      )}

                      <div
                        className={`collapse ${
                          functionItem.isCollapsed ? "show" : ""
                        }`}
                      >
                        {/* Your content for the collapse drawer */}
                        {/* Replace this with your desired content for each input */}
                        {/* strategic imparative data here input*/}
                        <div style={{ marginTop: "10px" }}>
                          {functionItem.strategic_imperative &&
                            functionItem.strategic_imperative.length > 0 &&
                            functionItem.strategic_imperative.map(
                              (simpItem, simpIndex) => (
                                <>
                                  <div key={simpIndex}>
                                    {editMode &&
                                    simpItem.id === currentItemId ? (
                                      <div style={{ width: "80%" }}>
                                        <div
                                          style={{
                                            display: "flex",
                                            width: "100%",
                                            justifyContent: "space-evenly",
                                            alignItems: "center",
                                            marginLeft: "40px",
                                            marginBottom: "6px",
                                          }}
                                        >
                                          <InputField
                                            value={newStrategicItem}
                                            onChange={(e) =>
                                              setNewStrategicItem(
                                                e.target.value
                                              )
                                            }
                                            handleSubmit={(e) =>
                                              handleAddStrategicItem(
                                                e,
                                                functionIndex,
                                                functionItem.id,
                                                simpItem.id,
                                                simpIndex
                                              )
                                            }
                                            Close={() => setEditMode(false)}
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="strategic">
                                        <div
                                          className="simpContainer"
                                          key={simpIndex}
                                          style={{
                                            background:
                                              currentImperativeId ===
                                              simpItem.id
                                                ? "#D9F6E4"
                                                : "rgba(255, 255, 255, 1)",
                                          }}
                                        >
                                          <div>
                                            <img
                                              src={ArrowSIMP}
                                              width={"24px"}
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "10px",
                                                transition:
                                                  "transform 0.3s ease",
                                                transform: collapsedItems[
                                                  simpItem.id
                                                ]
                                                  ? "rotate(0)"
                                                  : "rotate(180deg)",
                                              }}
                                              onClick={() =>
                                                handleCollapseToggleSimp(
                                                  simpItem.id
                                                )
                                              }
                                            />
                                              <span
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  maxWidth: "800px",
                                                }}
                                              >
                                              <button
                                                style={{
                                                  border: "none",
                                                  backgroundColor:
                                                    "transparent",
                                                  fontSize:
                                                    "var(--sub-heading-font-size)",

                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  textAlign: "left",
                                                  padding: 0,
                                                  flex: 1,
                                                  minWidth: 0, // leave space for the imag
                                                }}
                                                type="button"
                                                title={simpItem.name}
                                                onClick={() => {
                                                  handleSidebar(
                                                    true,
                                                    simpItem,
                                                    "Write a functional goal name",
                                                    "functional_goal",
                                                    simpItem.id,
                                                    functionIndex,
                                                    simpIndex,
                                                    functionItem.name + " > Edit Functional Goal",
                                                    false,
                                                    simpItem &&
                                                      simpItem.user_permission &&
                                                      simpItem
                                                        ?.user_permission[0],
                                                    simpItem &&
                                                      simpItem.due_date_perm,
                                                    functionItem.name,
                                                    simpItem.name
                                                  );
                                                  setCurrentImperativeId(
                                                    simpItem.id
                                                  );
                                                  setCurrentMilestoneId("");
                                                  setCurrentFunctionId("");
                                                }}
                                              >
                                                {simpItem.name}
                                              </button>
                                            </span>
                                              <img
                                                src={FunctionalGoal}
                                                width={"20px"}
                                                style={{
                                                  marginLeft: "8px",
                                                  flexShrink: 0,
                                                }}
                                              />
                                          </div>
                                          {/* add more options here for strategic imperative */}

                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <DisabledGoalSelector
                                              options={simpItem.goals_dt}
                                              selectedGoals={simpItem.goals_dt?.filter(
                                                (goal) => goal.is_active
                                              )}
                                              // simpItem_id={simpItem.id}
                                            />
                                            <div
                                              style={{
                                                display: isMilestoneVisible
                                                  ? "block"
                                                  : "none",
                                                alignItems: "center",
                                              }}
                                            >
                                              {(selectedSubMenuPermission ===
                                                "write" ||
                                                selectedSubMenuPermission ===
                                                  "admin") &&
                                                simpItem &&
                                                simpItem?.user_permission &&
                                                simpItem?.user_permission[0] ===
                                                  "write" && (
                                                  <div
                                                    style={{
                                                      display: milestoneItems[
                                                        functionIndex
                                                      ]?.[simpIndex]
                                                        ? "none"
                                                        : "flex",
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <button
                                                      style={{
                                                        marginLeft: "10px",
                                                        color: "#0a5f59",
                                                        fontSize:
                                                          "var(--sub-heading-font-size)",
                                                      }}
                                                      className="buttonStyle"
                                                      type="button"
                                                      // onClick={() =>
                                                      //   setMilestoneModel(
                                                      //     functionIndex,
                                                      //     simpIndex,
                                                      //     false
                                                      //   )
                                                      // }
                                                      onClick={() => {
                                                        handleSidebar(
                                                          false,
                                                          false,
                                                          "Write a milestone name",
                                                          "milestone",
                                                          simpItem.id,
                                                          functionIndex,
                                                          simpIndex,
                                                          functionItem.name +
                                                            " > New Milestone",
                                                          false,
                                                          simpItem &&
                                                            simpItem.user_permission &&
                                                            simpItem
                                                              ?.user_permission[0],
                                                          simpItem &&
                                                            simpItem.due_date_perm,
                                                          functionItem.name,
                                                          simpItem.name
                                                        );
                                                        setCurrentImperativeId(
                                                          simpItem.id
                                                        );
                                                        setCurrentMilestoneId(
                                                          ""
                                                        );
                                                        setCurrentFunctionId(
                                                          ""
                                                        );
                                                      }}
                                                    >
                                                      <img
                                                        src={AddColorIcon}
                                                        width={16}
                                                        style={{
                                                          marginRight: "5px",
                                                        }}
                                                      />
                                                      Add Milestones
                                                    </button>
                                                  </div>
                                                )}
                                            </div>
                                            <div
                                              style={{
                                                minWidth: "130px",
                                                textAlign: "left",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              {simpItem.status && (
                                                <div
                                                  style={{
                                                    marginBottom: "0px",
                                                    marginLeft: "15px",
                                                  }}
                                                >
                                                  {createStatus(
                                                    simpItem.status
                                                  )}
                                                </div>
                                              )}
                                            </div>

                                            <div style={{ margin: "0px 10px" }}>
                                              {simpItem.assigned_to.length >
                                                0 &&
                                              simpItem.assigned_to.find(
                                                (item) => item.is_active
                                              ) ? (
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip
                                                      id={`tooltip-${
                                                        simpItem.assigned_to.find(
                                                          (item) =>
                                                            item.is_active
                                                        ).label
                                                      }`}
                                                    >
                                                      {
                                                        simpItem.assigned_to.find(
                                                          (item) =>
                                                            item.is_active
                                                        ).label
                                                      }
                                                    </Tooltip>
                                                  }
                                                >
                                                      <div style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        // margin: "10px",
                                                      }}>
                                                        <img
                                                          style={{ margin: "10px" }}
                                                          alt=""
                                                          src={createImageFromInitials(
                                                            30,
                                                            simpItem.assigned_to.find(
                                                              (item) => item.is_active
                                                            ).label,
                                                            getRandomColor(
                                                              simpItem.assigned_to.find(
                                                                (item) =>
                                                                  item.is_active
                                                              ).label
                                                            )
                                                          )}
                                                        />
                                                        {(simpItem.assigned_to.find((item) => item.is_active)?.status ===
                                                          "Inactive" || simpItem.assigned_to.find((item) => item.is_active)?.bi_mapping === false) && (
                                                            < TiDelete
                                                              size={14}
                                                              style={{
                                                                position: "absolute",
                                                                bottom: "10px",
                                                                right: "10px",
                                                                background: "#fff",
                                                                borderRadius: "50%",
                                                                color: "#DC2626",
                                                                padding: "1px",
                                                              }}
                                                            />
                                                          )}
                                                      </div>
                                                    </OverlayTrigger>
                                              ) : (
                                                <img
                                                  alt=""
                                                  src={Assign}
                                                  style={{ margin: "10px" }}
                                                />
                                              )}
                                            </div>

                                            <img
                                              alt="chevronright"
                                              src={ChevronRight}
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                handleSidebar(
                                                  true,
                                                  simpItem,
                                                  "Write a functional goal name",
                                                  "functional_goal",
                                                  simpItem.id,
                                                  functionIndex,
                                                  simpIndex,
                                                  functionItem.name + " > Edit Functional Goal",
                                                  false,
                                                  simpItem &&
                                                    simpItem.user_permission &&
                                                    simpItem
                                                      ?.user_permission[0],
                                                  simpItem &&
                                                    simpItem.due_date_perm,
                                                  functionItem.name,
                                                  simpItem.name
                                                );
                                                setCurrentImperativeId(
                                                  simpItem.id
                                                );
                                                setCurrentMilestoneId("");
                                                setCurrentFunctionId("");
                                                // setHighlightedRowIndex(sim.id);
                                              }}
                                            />
                                            {/* 
                                          <div
                                            className="ElipsisVerticalIcon"
                                            onClick={() => {
                                              handleVerticalIconClick();
                                            }}
                                            onMouseLeave={
                                              handleVerticalIconMouseLeave
                                            }
                                          >
                                            <img
                                              src={ElipsisVerticalIcon}
                                              width={"4px"}
                                              alt="Ellipsis Vertical Icon"
                                            />
                                            {onElipsisshowIcons && (
                                              <div className="IconsContainers">
                                                <div className="ElipsisEditIcon">
                                                  <button
                                                    type="button"
                                                    className="Addobjstyle"
                                                    onClick={() =>
                                                      handleEditClick(
                                                        "strategicItem",
                                                        simpItem.name,
                                                        simpItem.id
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      src={EditIcon}
                                                      width={"18px"}
                                                      alt="Edit Icon"
                                                    />
                                                    <span
                                                      style={{
                                                        paddingLeft: "10px",
                                                      }}
                                                    >
                                                      Edit
                                                    </span>
                                                  </button>
                                                </div>

                                                <div
                                                  className="ElipsisDeleteIcon"
                                                  onClick={() =>
                                                    handleStrategicImpDelete(
                                                      functionIndex,
                                                      simpIndex,
                                                      simpItem.id
                                                    )
                                                  }
                                                >
                                                  <img
                                                    style={{
                                                      opacity: ".7",
                                                    }}
                                                    src={DeleteIcon}
                                                    width={"24px"}
                                                    alt="Delete Icon"
                                                  />
                                                  <span
                                                    style={{
                                                      paddingLeft: "10px",
                                                    }}
                                                  >
                                                    Delete
                                                  </span>
                                                </div>
                                              </div>
                                            )}
                                          </div> */}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {!collapsedItems[simpItem.id] && (
                                      <div>
                                        <div
                                          style={{
                                            marginLeft: "40px",
                                          }}
                                        >
                                          {simpItem.milestones &&
                                            simpItem.milestones.length > 0 &&
                                            simpItem.milestones.map(
                                              (item, index) => (
                                                <div key={item.id}>
                                                  <div
                                                    style={{
                                                      position: "relative",
                                                      alignItems: "center",
                                                    }}
                                                    onMouseEnter={() =>
                                                      setShowIcons(item.id)
                                                    }
                                                    onMouseLeave={() =>
                                                      setShowIcons(null)
                                                    }
                                                  >
                                                    <div
                                                      className="Milestones"
                                                      style={{
                                                        background:
                                                          currentMilestoneId ===
                                                          item.id
                                                            ? "#D9F6E4"
                                                            : "rgba(248, 248, 248, 1)",
                                                      }}
                                                    >
                                                      {/* edit option here for milestones */}
                                                      {/* {editMode &&
                                                    item.id ===
                                                      currentItemId ? (
                                                      <div
                                                        style={{
                                                          width: "65%",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            width: "100%",
                                                            justifyContent:
                                                              "space-evenly",
                                                            alignItems:
                                                              "center",
                                                            marginLeft: "40px",
                                                            // marginBottom: "6px",
                                                          }}
                                                        >
                                                          <InputField
                                                            value={
                                                              newMilestoneItem
                                                            }
                                                            onChange={(e) =>
                                                              setNewMilestoneItem(
                                                                e.target.value
                                                              )
                                                            }
                                                            handleSubmit={(e) =>
                                                              handleAddMilestoneItem(
                                                                e,
                                                                functionIndex,
                                                                simpIndex,
                                                                index,
                                                                simpItem.id,
                                                                item.id
                                                              )
                                                            }
                                                            Close={() =>
                                                              setEditMode(false)
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                    ) : ( */}
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          justifyContent:
                                                            "space-between",
                                                          // overflow: "hidden",
                                                          width: "100%",
                                                          // paddingTop: "10px",
                                                          // background:
                                                          //   currentMilestoneId ===
                                                          //   item.id
                                                          //     ? "#D9F6E4"
                                                          //     : "linear-gradient(0deg, #eeeeee, #eeeeee),linear-gradient(0deg, #f8f8f8, #f8f8f8)",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            width: "65%",
                                                            alignItems:
                                                              "center",
                                                            display: "flex",
                                                          }}
                                                          onClick={() => {
                                                            handleSidebar(
                                                              true,
                                                              item,
                                                              "Write a milestone name",
                                                              "milestone",
                                                              simpItem.id,
                                                              functionIndex,
                                                              simpIndex,
                                                              functionItem.name + " > Edit Milestone",
                                                              index,
                                                              item &&
                                                                item?.user_permission &&
                                                                item
                                                                  ?.user_permission[0],
                                                              simpItem &&
                                                                simpItem.due_date_perm,
                                                              functionItem.name,
                                                              simpItem.name
                                                            );
                                                            setCurrentMilestoneId(
                                                              item.id
                                                            );
                                                            setCurrentImperativeId(
                                                              ""
                                                            );
                                                            setCurrentFunctionId(
                                                              ""
                                                            );
                                                            // setHighlightedRowIndex(sim.id);
                                                          }}
                                                        >
                                                          <img
                                                            src={Repeat}
                                                            width={"24px"}
                                                          />
                                                          <span
                                                            style={{
                                                              overflow:
                                                                "hidden",
                                                              width: "100%",
                                                              textOverflow:
                                                                "ellipsis",
                                                              whiteSpace:
                                                                "nowrap",
                                                              border: "none",
                                                              backgroundColor:
                                                                "transparent",
                                                              fontSize:
                                                                "var(--sub-heading-font-size)",
                                                            }}
                                                            type="button"
                                                            title={item.name}
                                                          >
                                                            {item.name}
                                                          </span>
                                                        </div>

                                                        {/* edit remove component */}
                                                        {/* <ManageOptions
                                                          handleEditClick={() =>
                                                            handleEditClick(
                                                              "milestone",
                                                              item.name,
                                                              item.id
                                                            )
                                                          }
                                                          handleDeleteClick={() =>
                                                            handleMilestoneDelete(
                                                              functionIndex,
                                                              simpIndex,
                                                              index,
                                                              item.id
                                                            )
                                                          }
                                                          showIcons={
                                                            showIcons ===
                                                            item.id
                                                          }
                                                        /> */}

                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <>
                                                            <div
                                                              style={{
                                                                whiteSpace:
                                                                  "nowrap",
                                                              }}
                                                            >
                                                              {item.due_date ? (
                                                                <div
                                                                  style={{
                                                                    marginBottom:
                                                                      "0px",
                                                                    marginRight:
                                                                      "20px",
                                                                  }}
                                                                >
                                                                  {
                                                                    item.due_date
                                                                  }
                                                                </div>
                                                              ) : (
                                                                <div
                                                                  style={{
                                                                    color:
                                                                      "gray",
                                                                    marginBottom:
                                                                      "0px",
                                                                    marginRight:
                                                                      "20px",
                                                                    marginLeft:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  Due Date
                                                                </div>
                                                              )}
                                                            </div>
                                                            <div
                                                              style={{
                                                                minWidth:
                                                                  "140px",
                                                                textAlign:
                                                                  "left",
                                                                whiteSpace:
                                                                  "nowrap",
                                                              }}
                                                            >
                                                              {item.status && (
                                                                <div
                                                                  style={{
                                                                    marginBottom:
                                                                      "0px",
                                                                    marginRight:
                                                                      "20px",
                                                                    marginLeft:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  {createStatus(
                                                                    item.status
                                                                  )}
                                                                </div>
                                                              )}
                                                            </div>
                                                            <div
                                                              style={{
                                                                margin:
                                                                  "0px 10px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              {item.assigned_to
                                                                .length > 0 &&
                                                              item.assigned_to.find(
                                                                (item) =>
                                                                  item.is_active
                                                              ) ? (
                                                                <OverlayTrigger
                                                                  placement="top"
                                                                  overlay={
                                                                    <Tooltip
                                                                      id={`tooltip-${
                                                                        item.assigned_to.find(
                                                                          (
                                                                            item
                                                                          ) =>
                                                                            item.is_active
                                                                        ).label
                                                                      }`}
                                                                    >
                                                                      {
                                                                        item.assigned_to.find(
                                                                          (
                                                                            item
                                                                          ) =>
                                                                            item.is_active
                                                                        ).label
                                                                      }
                                                                    </Tooltip>
                                                                  }
                                                                >
                                                                  <div style={{
                                                                    position: "relative",
                                                                    display: "inline-block",
                                                                    // margin: "10px",
                                                                  }}>
                                                                    <img
                                                                      alt=""
                                                                      src={createImageFromInitials(
                                                                        30,
                                                                        item.assigned_to.find(
                                                                          (
                                                                            item
                                                                          ) =>
                                                                            item.is_active
                                                                        ).label,
                                                                        getRandomColor(
                                                                          item.assigned_to.find(
                                                                            (
                                                                              item
                                                                            ) =>
                                                                              item.is_active
                                                                          ).label
                                                                        )
                                                                      )}
                                                                    />
                                                                    {(item.assigned_to.find((item) => item.is_active)?.status ===
                                                                      "Inactive" || item.assigned_to.find((item) => item.is_active)?.bi_mapping === false) && (
                                                                        < TiDelete
                                                                          size={14}
                                                                          style={{
                                                                            position: "absolute",
                                                                            bottom: "0px",
                                                                            right: "0px",
                                                                            background: "#fff",
                                                                            borderRadius: "50%",
                                                                            color: "#DC2626",
                                                                            padding: "1px",
                                                                          }}
                                                                        />
                                                                      )}
                                                                  </div>
                                                                </OverlayTrigger>
                                                              ) : (
                                                                <img
                                                                  style={{
                                                                    marginLeft:
                                                                      "5px",
                                                                  }}
                                                                  alt=""
                                                                  src={Assign}
                                                                />
                                                              )}
                                                            </div>
                                                            <div
                                                              style={{
                                                                width: "20px",
                                                              }}
                                                            >
                                                              {showIcons ===
                                                                item.id && (
                                                                <img
                                                                  alt="chevronright"
                                                                  src={
                                                                    ChevronRight
                                                                  }
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() => {
                                                                    handleSidebar(
                                                                      true,
                                                                      item,
                                                                      "Write a milestone name",
                                                                      "milestone",
                                                                      simpItem.id,
                                                                      functionIndex,
                                                                      simpIndex,
                                                                      functionItem.name + " > Edit Milestone",
                                                                      index,
                                                                      item &&
                                                                        item?.user_permission &&
                                                                        item
                                                                          ?.user_permission[0],
                                                                      simpItem &&
                                                                        simpItem.due_date_perm,
                                                                      functionItem.name,
                                                                      simpItem.name
                                                                    );
                                                                    setCurrentMilestoneId(
                                                                      item.id
                                                                    );
                                                                    setCurrentImperativeId(
                                                                      ""
                                                                    );
                                                                    setCurrentFunctionId(
                                                                      ""
                                                                    );
                                                                    // setHighlightedRowIndex(sim.id);
                                                                  }}
                                                                />
                                                              )}
                                                            </div>
                                                          </>
                                                        </div>
                                                      </div>
                                                      {/* )} */}
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </>
                              )
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  // display: isFunctionVisible ? "block" : "none",
                  display: "none",
                  alignItems: "center",
                  width: "99%",
                }}
              >
                <div
                  style={{
                    display: !functionModel ? "flex" : "none",
                    width: "99%",
                  }}
                >
                  <button
                    className="buttonStyle"
                    type="button"
                    onClick={openFunctionModel}
                  >
                    <span className="add-icon">+</span>Add Function
                  </button>
                </div>
                <div
                  className="ObjectInput"
                  style={{ display: functionModel ? "flex" : "none" }}
                >
                  <div
                    style={{
                      width: "50%",
                      display: "flex",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                    }}
                  >
                    <InputField
                      onChange={(e) => setFunctionData(e.target.value)}
                      Close={(e) => setFunctionModel(false)}
                      handleSubmit={(e) => handleFunctionSubmit(e)}
                      placeholder="Add Function here"
                      name="function"
                    />
                  </div>
                  {/* add existing popup here */}
                  <div>
                    <AddExistingpopup
                      Title="Add Existing function"
                      ModalTitle="My Function Library"
                      handleClose={() => handlePopupClose()}
                      show={showFunctionPopup}
                      AddFolder={AddFolder}
                      handleShow={() => handlePopupShow()}
                      stage={"functions"}
                    />
                  </div>
                </div>
              </div>
              {showDuplicateTaskPopup && (
                <DuplicateTaskPopup
                  ModalTitle="Duplicate Task"
                  handleClose={() => handleDTPopupClose()}
                  show={showDuplicateTaskPopup}
                  duplicateTaskName={duplicateTaskName}
                  duplicateTaskId={duplicateTaskId}
                />
              )}
              {isSidebarOpen && (
                <XLExecutionPlanSidebar
                  userPermission={userPermission}
                  userDueDatePermission={userDueDatePermission}
                  workboard={false}
                  isEdit={isEdit}
                  data={selectedData}
                  type={sidebarType}
                  placeholder={placeholder}
                  goalData={dropdownGoalData}
                  empData={empData}
                  parentId={selectedItemId}
                  statusData={statusData}
                  priorityData={priorityData}
                  breadcrumbs={breadcrumbs}
                  functionIndex={currentFunctionIndex}
                  impIndex={currentImperativeIndex}
                  impid={currentImperativeId}
                  milestoneIndex={currentMilestoneIndex}
                  milestonedataId={currentMilestoneId}
                  handleMilestoneEdit={handleMilestoneEdit}
                  handleStrategicImpEdit={handleStrategicImpEdit}
                  handleStrategicImpDelete={handleStrategicImpDelete}
                  handleMilestoneDelete={handleMilestoneDelete}
                  onClose={() => {
                    setIsSidebarOpen(false);
                    setCurrentFunctionId("");
                    setCurrentImperativeId("");
                    setCurrentMilestoneId("");
                  }}
                  setIsSidebarOpen={(value) => {
                    setIsSidebarOpen(value);
                  }}
                  handleDuplicateTaskClick={(id, title) =>
                    handleDuplicateTaskClick(id, title)
                  }
                  handleDTPopupShow={() => handleDTPopupShow()}
                  functionItemName={functionItemName}
                  simpItemName={simpItemName}
                />
              )}
            </>
          ) : (
            <div style={{ margin: "10px", fontWeight:"var(--heading-font-weight)" }}>
              <span>No functions are currently assigned.</span>
            </div>
          )}
        </form>
        <div>
          <CommentSection />
          {selectedHelpInfoSidebar && <SideNavHelpInfo />}
        </div>
      </div>
    </motion.div>
  );
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <>
        <MainComponent
          maincontent={content}
          // showTemplate={true}
          showSelector={true}
          showButtons={true}
          showTreeViewButton={true}
          handleTreeViewOpen={handleTreeViewOpen}
          handleNext={handleClick}
          handleBackButton={handleBack}
          showProducts={true}
          breadcrumbParent={"GTM Execution"}
          breadcrumbChild={"XL Execution Plan"}
          documentName={"XL Execution Plan"}
          helpKey={keys["XL Execution Plan"].Name}
          image={"question"}
        />
      </>
    );
  }
}

export default XLExecutionPlan;



const AiEditDrawer = ({
  goals,
  handleAiEdit,
  aiFullScreenMode,
  setAiFullScreenMode,
  dispatch,
  aiFunctionId
}) => {
  const [localGoals, setLocalGoals] = useState(goals);

  useEffect(() => {
    setLocalGoals(goals);
  }, [goals]);

  const updateLocalGoal = (gi, field, value) => {
    setLocalGoals(prev => {
      const copy = [...prev];
      copy[gi] = { ...copy[gi], [field]: value };
      return copy;
    });
  };

  const updateLocalMilestone = (gi, mi, field, value) => {
    setLocalGoals(prev => {
      const copy = [...prev];
      const milestones = [...copy[gi].Milestones];
      milestones[mi] = { ...milestones[mi], [field]: value };
      copy[gi] = { ...copy[gi], Milestones: milestones };
      return copy;
    });
  };

  const saveAll = (e) => {
    // THIS is your final payload
    e.preventDefault()

    dispatch(postaiGeneratedGoals(localStorage.getItem('bi_id'),localStorage.getItem('product_id'),localGoals, aiFunctionId))
    
  };

  return (
    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", borderBottom: "1px solid lightGray" }}>
        <div style={{ maxWidth: "60%", textOverflow: "ellipsis", overflow: "hidden", paddingTop: "4px", fontSize: "var(--sub-heading-font-size)", fontWeight: "var(--heading-font-weight)" }}>
          Review and Edit Generated Functional Goals and Milestones
        </div>

        <div>
          {!aiFullScreenMode ? (
                    <a href="#" className="fullscreen" style={{fontSize:'25px', marginRight: '10px', color:'gray'}} onClick={()=> setAiFullScreenMode(true)}>
                      <AiOutlineCaretRight />
                    </a>
                  ) : (
                    <a href="#" className="fullscreen" style={{fontSize:'25px', marginRight: '10px', color:'gray'}} onClick={()=> setAiFullScreenMode(false)}>
                      <AiOutlineCaretLeft />
                    </a>
                  )}
          <Button color="inherit" onClick={() => { handleAiEdit();
                                                    setTimeout(() => {
                                                      setAiFullScreenMode(false);
                                                    }, 1000); // 1 second delay
                                                  }} style={{ border: "2px solid darkgray", borderRadius: "10px", color: "gray", backgroundColor: "white" }}>
            Cancel
          </Button>

          <Button type="submit" form="ai-edit-form" color="inherit"  style={{width:'fit-content', color: "white", backgroundColor: "#0a5f59", border: "3px solid #0a5f59", marginLeft: "20px", padding: "4px 10px" }}>
            Create Tasks
          </Button>
        </div>
      </div>

      {/* Content */}
      <form id="ai-edit-form" onSubmit={saveAll} style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", backgroundColor: "whitesmoke", flexGrow: 1, overflowY: "auto", overflowX: "hidden", paddingBottom:'100px' }}>
        {localGoals.map((goal, gi) => (
          <div key={gi} className="goal-card">
            <textarea
              className="goal-milestone"
              value={goal.subject}
              required
              onChange={(e) =>
                updateLocalGoal(gi, "subject", e.target.value)
              }
            />

            <textarea
              className="ai-description"
              value={goal["description"]}
              onChange={(e) =>
                updateLocalGoal(gi, "description", e.target.value)
              }
            />

            {goal.Milestones.map((ms, mi) => (
              <div key={mi} className="milestone">
                <textarea
                  className="goal-milestone"
                  style={{ backgroundColor: "rgb(233, 239, 245)" }}
                  value={ms.subject}
                  required
                  onChange={(e) =>
                    updateLocalMilestone(gi, mi, "subject", e.target.value)
                  }
                />

                <textarea
                  className="ai-description"
                  value={ms["description"]}
                  onChange={(e) =>
                    updateLocalMilestone(
                      gi,
                      mi,
                      "description",
                      e.target.value
                    )
                  }
                />
              </div>
            ))}
          </div>
        ))}
      </form>
    </div>
  );
};
